import { Pipe, PipeTransform } from '@angular/core';
import { TipoEmpresa } from '../../models/auth/TipoEmpresa';

@Pipe({
  name: 'badgeTipoEmpresa',
})
export class BadgeTipoEmpresaPipe implements PipeTransform {
  transform(tipoEmpresa: TipoEmpresa): string {
    return {
      [TipoEmpresa.Matriz]: 'bg-success',
      [TipoEmpresa.Filial]: 'bg-warning',
    }[tipoEmpresa];
  }
}
